import { css } from '@emotion/react'
import { useMemo } from 'react'
import { useTextEditor } from '../../TextEditor'
import * as styles from '../components/FullControlBar/styles'

export const useFullControlBarStyles = (isInsidePopover?: boolean) => {
  const { theme } = useTextEditor()

  return useMemo(
    () => ({
      button: css(styles.button({ theme })),
      group: isInsidePopover ? css(styles.popoverGroup) : undefined,
    }),
    [theme, isInsidePopover]
  )
}
